module.exports = __webpack_public_path__ + "static/media/pbl-logo-white.9d28c2ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pbl-logo-white.svg
// module id = 797
// module chunks = 0